import type { CommissionProgramConsentNode } from "../consents/types";
import type { PersonGrpIaaSummary } from "@/pages/people/[pgaId]/benefits/grp/types";

export const commissionProgramConsentFixtures: CommissionProgramConsentNode[] = [
  {
    id: "commission-consent-ada-2026",
    commissionCampaignId: "commission-campaign-2026-acme",
    crmPersonId: "person-ada",
    attributionModel: "FACILITY",
    ownership: "OWNER",
    startsAt: "2026-01-01T00:00:00Z",
    endsAt: null,
    status: "ACTIVE"
  },
  {
    id: "commission-consent-bobby-2025",
    commissionCampaignId: "commission-campaign-2025-acme",
    crmPersonId: "person-bobby",
    attributionModel: "PERSONAL",
    ownership: "NON_OWNER",
    startsAt: "2025-01-01T00:00:00Z",
    endsAt: "2025-12-31T23:59:59Z",
    status: "ENDED"
  }
];

export const personGrpIaaSummaryByPgaId: Record<string, PersonGrpIaaSummary> = {
  "12345678": {
    facilityName: "Oak Hills Golf Club",
    receiverPgaId: "12345678",
    splitPercent: 100,
    status: "ACTIVE",
    effectiveDate: "2026-01-01"
  },
  "87654321": {
    facilityName: "Pine Valley Country Club",
    receiverPgaId: "87654321",
    splitPercent: 60,
    status: "DRAFT",
    effectiveDate: "2026-04-01"
  }
};
